import script from "./CounterComment.vue?vue&type=script&setup=true&lang=js"
export * from "./CounterComment.vue?vue&type=script&setup=true&lang=js"

import "./CounterComment.vue?vue&type=style&index=0&id=70bc6b40&lang=scss"

const __exports__ = script;

export default __exports__